import { IMAGES, RETREAT } from "./site";

export const SITE_URL = "https://bblessedcc.com";

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      name: "Beyond Blessed Consulting & Counseling, LLC",
      url: SITE_URL,
      logo: IMAGES.logo,
      email: "info@bblessedcc.com",
      telephone: "+1-813-330-0423",
    },
    {
      "@type": "MedicalBusiness",
      "@id": `${SITE_URL}/#business`,
      name: "Beyond Blessed Consulting & Counseling, LLC",
      parentOrganization: { "@id": `${SITE_URL}/#organization` },
      url: SITE_URL,
      image: `${SITE_URL}/og-image.jpg`,
      telephone: "+1-813-330-0423",
      email: "info@bblessedcc.com",
      priceRange: "$75–$175",
      description:
        "Christian faith-based therapy in Wesley Chapel, Tampa & telehealth statewide. Individual, couples, and group counseling, therapy intensives, and retreats.",
      address: {
        "@type": "PostalAddress",
        streetAddress: "30740 State Road 54, Suite 112",
        addressLocality: "Wesley Chapel",
        addressRegion: "FL",
        postalCode: "33543",
        addressCountry: "US",
      },
      areaServed: [
        { "@type": "City", name: "Wesley Chapel, FL" },
        { "@type": "City", name: "Tampa, FL" },
        { "@type": "State", name: "Florida" },
      ],
    },
  ],
};

export const TEAM_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      name: "Tanya Richardson",
      jobTitle: "Founder & Lead Psychotherapist",
      description:
        "Licensed Mental Health Counselor (LMHC) specializing in trauma recovery, anxiety, and Christian counseling for women.",
      hasCredential: {
        "@type": "EducationalOccupationalCredential",
        credentialCategory: "license",
        name: "Licensed Mental Health Counselor (LMHC)",
      },
      image: IMAGES.tanya,
      worksFor: { "@id": `${SITE_URL}/#business` },
    },
    {
      "@type": "Person",
      name: "Adrianne",
      jobTitle: "Associate Clinician",
      description: "Master's Level Clinician / Registered Mental Health Counselor Intern.",
      image: IMAGES.adrianne,
      worksFor: { "@id": `${SITE_URL}/#business` },
    },
  ],
};

export const EVENT_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Event",
  name: `${RETREAT.name} — ${RETREAT.subtitle}`,
  description: RETREAT.intro,
  startDate: "2027-05-14",
  endDate: "2027-05-17",
  eventStatus: "https://schema.org/EventScheduled",
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  location: {
    "@type": "Place",
    name: "Hotel Conference Room Near Beachfront",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Clearwater",
      addressRegion: "FL",
      addressCountry: "US",
    },
  },
  image: [`${SITE_URL}/og-image.jpg`],
  organizer: { "@id": `${SITE_URL}/#organization` },
  offers: {
    "@type": "Offer",
    url: `${SITE_URL}/retreats`,
    price: "1500",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
  },
};

export const articleSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.title,
  description: post.excerpt,
  image: [post.cover],
  datePublished: post.dateISO,
  author: {
    "@type": "Organization",
    name: "Beyond Blessed Consulting & Counseling, LLC",
    url: SITE_URL,
  },
  publisher: {
    "@type": "Organization",
    name: "Beyond Blessed Consulting & Counseling, LLC",
    url: SITE_URL,
    logo: IMAGES.logo,
  },
  mainEntityOfPage: `${SITE_URL}/blog/${post.slug}`,
});
